import React from "react";
import PageHero from "../components/PageHero";
import usePageMeta from "../hooks/usePageMeta";

export function Privacy() {
  usePageMeta({ title: "Privacy Policy", description: "How Thrive Bridge collects, uses and protects your information." });
  return (
    <>
      <PageHero eyebrow="Privacy" title="Your privacy matters to us." lead="A plain-English summary of how we look after your information." />
      <section className="container-page section-spacing max-w-3xl text-[var(--tb-text-2)] text-lg space-y-5">
        <h2 className="font-serif-display text-2xl text-[var(--tb-text)] mt-2">What we collect</h2>
        <p>We collect only the information you choose to share with us through our forms — for example your name, contact details and a description of what you'd like support with.</p>
        <h2 className="font-serif-display text-2xl text-[var(--tb-text)] mt-2">How we use it</h2>
        <p>We use your information solely to contact you about your enquiry, deliver our services, and improve what we do. We never sell your data.</p>
        <h2 className="font-serif-display text-2xl text-[var(--tb-text)] mt-2">How we protect it</h2>
        <p>Your data is stored securely in line with UK GDPR and the Data Protection Act 2018. You can ask us at any time to access, correct or delete your information.</p>
        <h2 className="font-serif-display text-2xl text-[var(--tb-text)] mt-2">Cookies</h2>
        <p>We use essential cookies to keep the site working and optional analytics cookies to understand how people use it. You can change your choice at any time.</p>
        <p className="text-sm text-[var(--tb-muted)]">This is placeholder copy — please replace with your formal policy.</p>
      </section>
    </>
  );
}

export function Terms() {
  usePageMeta({ title: "Terms of Use", description: "Terms governing your use of the Thrive Bridge website." });
  return (
    <>
      <PageHero eyebrow="Terms" title="Terms of use" lead="The basics of using this website, written in plain English." />
      <section className="container-page section-spacing max-w-3xl text-[var(--tb-text-2)] text-lg space-y-5">
        <p>By using this site you agree to use it lawfully and respectfully. The information on this site is provided for general guidance — it is not a substitute for professional advice or crisis support.</p>
        <p>If you are in crisis please call 999, or contact Samaritans on 116 123 (free, 24/7).</p>
        <p className="text-sm text-[var(--tb-muted)]">This is placeholder copy — please replace with your formal terms.</p>
      </section>
    </>
  );
}

export function NotFound() {
  usePageMeta({ title: "Page not found", description: "The page you were looking for could not be found." });
  return (
    <section className="container-page section-spacing text-center">
      <p className="text-xs font-semibold tracking-widest uppercase text-[var(--tb-primary)]">404</p>
      <h1 className="font-serif-display mt-3 text-4xl md:text-5xl text-[var(--tb-text)]">We couldn't find that page</h1>
      <p className="mt-4 text-[var(--tb-text-2)] max-w-lg mx-auto">The page may have moved or no longer exists. Let's get you back to safe ground.</p>
      <a href="/" className="mt-6 inline-flex items-center rounded-full bg-[var(--tb-primary)] text-white px-6 py-3 font-semibold">Go home</a>
    </section>
  );
}
